<template>
	<!-- Main Wrapper -->
	<div class="main-wrapper">
		<layout-header></layout-header>
		<layout-sidebar></layout-sidebar>
		<!-- Page Wrapper -->
		<div class="page-wrapper">
			<div class="content container-fluid">
				<!-- Page Header -->
				<div class="page-header">
					<div class="content-page-header">
						<h5>{{ title }}</h5>
						<div class="list-btn">
							<ul class="filter-list">
								<li>
									<router-link class="btn btn-primary" to="/membership-plans"
										><i class="feather feather-repeat me-2" aria-hidden="true"></i>Change
										Plan</router-link
									>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<!-- /Page Header -->

				<div class="row">
					<div class="col-sm-12">
						<div class="card-table">
							<div class="card-body">
								<div class="table-responsive">
									<a-table
										class="stripped table-hover"
										:columns="columns"
										:loading="isFetching"
										:data-source="subscriptions"
										:row-key="(record) => record.key"
										:pagination="false"
									>
										<template #bodyCell="{ column, record, index }">
											<template v-if="column.key === 'index'">
												<span>{{ index + 1 }}</span>
											</template>
											<template v-if="column.key === 'plan'">
												<span>{{ record.plan.name }}</span>
											</template>
											<template v-if="column.key === 'duration'">
												<span
													>{{
                          record.plan.duration
													}}
													month(s)</span
												>
											</template>
											<template v-if="column.key === 'amount'">
												<span>{{
                          settings === "NGN"
                            ? useCurrency(record.plan.amount_ngn)
                            : useCurrency(record.plan.amount_usd)
												}}</span>
											</template>
											<template v-if="column.key === 'starts_at'">
												<span>{{ formatted(record.starts_at) }}</span>
											</template>
											<template v-if="column.key === 'ends_at'">
												<span>{{
                          record.ends_at
                            ? formatted(record.ends_at)
                            : "Lifetime"
												}}</span>
											</template>
											<template v-if="column.key === 'status'">
												<span
													class="badge badge-pill text-capitalize"
													:class="{
                            'bg-success-light': record.status === 'active',
                            'bg-danger-light':
                              record.status === 'inactive' ||
                              record.status === 'cancelled' ||
                              record.status === 'completed',
                          }"
													>{{ record.status }}</span
												>
											</template>
											<template v-else-if="column.key === 'action'">
												<div class="d-flex align-items-center justify-content-start">
													<div class="dropdown dropdown-action">
														<a
															class="btn-action-icon"
															data-bs-toggle="dropdown"
															aria-expanded="false"
															>Action</a
														>
														<div class="dropdown-menu dropdown-menu-end">
															<ul>
																<!-- <li>
                                  <a class="dropdown-item"
                                    ><i class="far fa-eye me-2"></i>View</a
                                  >
                                </li> -->
																<li>
																	<router-link class="dropdown-item" to="/membership-plans"
																		><i class="fa fa-undo me-2"></i>Change plan</router-link
																	>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</template>
										</template>
									</a-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Page Wrapper -->
	</div>
	<!-- /Main Wrapper -->
</template>
<script setup>
import { computed, ref, onMounted } from "vue";
import { useCurrency } from "@/assets/composables/currency";
import { formatted } from "@/assets/composables/date";
import { useStore } from "vuex";

const store = useStore();
const title = "Subscriptions";
const isFetching = ref(false);
const currentDate = ref(new Date());
const startdate = ref(currentDate.value);

const settings = computed(() => {
  return store.getters["settings/settings"]?.currency;
});

const subscriptions = computed(() => {
  return store.getters["plan/subscriptions"];
});

const getSubscriptions = () => {
  isFetching.value = true;
  store
    .dispatch("plan/getSubscriptions")
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};
const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Plan",
    key: "plan",
    sorter: true,
  },
  {
    title: "Duration",
    key: "duration",
    sorter: true,
  },
  {
    title: "Amount",
    key: "amount",
    sorter: true,
  },
  {
    title: "Active Date",
    key: "starts_at",
    sorter: true,
  },
  {
    title: "Expiry Date",
    key: "ends_at",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

onMounted(() => {
  getSubscriptions();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }
});
</script>
